import {GUJARATSAMAGRACITY_ARE_LOADING, GUJARATSAMAGRACITY_FETCH_DATA_SUCCESS, GUJARATSAMAGRACITY_HAVE_ERROR} from '../actionType';

const initialState = {
    data: [],
    loading: true,
    error: []
  };
  
  export function GujaratSamagraCityReducer (state = initialState, action) {
    switch (action.type) {
        case GUJARATSAMAGRACITY_HAVE_ERROR:
            return {
                ...state,
                error:action.hasError,
                loading:false,
            }
    
        case GUJARATSAMAGRACITY_ARE_LOADING:
           return {
            ...state,
            loading:action.isLoading
        }
    
        case GUJARATSAMAGRACITY_FETCH_DATA_SUCCESS:
            return {
                ...state,
                data:action.GujaratSamagraCity,
                loading:false,
            }

        default:
            return state;
    }
}
